module.exports = __webpack_public_path__ + "img/logo1.7d46379d.png";